"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCreator = void 0;
var analytics_layer_1 = require("@pmi/analytics-layer");
var searchClick_1 = require("./searchClick");
var searchFilter_1 = require("./searchFilter");
var searchPagination_1 = require("./searchPagination");
var searchSort_1 = require("./searchSort");
var searchLoad_1 = require("./searchLoad");
var searchLoadB2B_1 = require("./searchLoadB2B");
var creatorMappings = (_a = {},
    _a[analytics_layer_1.SearchInteractionEventNames.SearchClick] = searchClick_1.searchClick,
    _a[analytics_layer_1.SearchInteractionEventNames.SearchLoad] = searchLoad_1.searchLoad,
    _a[analytics_layer_1.SearchInteractionEventNames.SearchLoadB2B] = searchLoadB2B_1.searchLoadB2B,
    _a[analytics_layer_1.SearchInteractionEventNames.SearchFilter] = searchFilter_1.searchFilter,
    _a[analytics_layer_1.SearchInteractionEventNames.SearcgPagination] = searchPagination_1.searchPagination,
    _a[analytics_layer_1.SearchInteractionEventNames.SearchSort] = searchSort_1.searchSort,
    _a);
var getCreator = function (eventName) { return creatorMappings[eventName]; };
exports.getCreator = getCreator;
